// extracted by mini-css-extract-plugin
export var headerContainer = "header-module--headerContainer--591af";
export var moreLessonsBtn = "header-module--moreLessonsBtn--60b93";
export var signUpBtn = "header-module--signUpBtn--9385d";